import * as React from "react";
import * as _ from "lodash";

import Gallery from "../../types/Gallery";
import Features from "../../types/Features";
import Guest from "../../types/Guest";
import Tac from "../../types/Tac";
import World from "../../world";
import { ManageTacs } from "./View";

export interface Props {
    gallery_name: string;
    world: World;
}

export interface State {
    gallery: Gallery;
    guests: Guest[];
    tacs: Tac[];
    tour?: boolean;
}

export default class ManageTacsController extends React.Component<Props, State> {
    private is_dead: boolean;
    private unlisten: () => void;
    private unwatch: () => void;
    private features: Features;
    private hasQuarantined: boolean;

    constructor(props: Props) {
        super(props);

        this.features = new Features();

        this.unlisten = props.world.listen(() => {
            this.setState({
                gallery: props.world.galleries[props.gallery_name],
                guests: props.world.listGalleryGuests(props.gallery_name),
                tacs: props.world.listGalleryTacs(props.gallery_name),
            });
        });

        props.world.fetchAllTacs(props.gallery_name);

        const gallery = props.world.galleries[props.gallery_name];

        if (gallery) {
            this.unwatch = props.world.watch(gallery.name, gallery.access_token);
            this.state = {
                gallery,
                guests: props.world.listGalleryGuests(props.gallery_name),
                tacs: props.world.listGalleryTacs(props.gallery_name),
            };
            // this.tour();
            return;
        }

        props.world.getGallery(props.gallery_name)
            .then(([name, err]) => {
                if (err) {
                    throw err;
                }
                if (this.is_dead) {
                    return;
                }
                this.unwatch = props.world.watch(name, gallery.access_token);
                this.setState({
                    gallery: props.world.galleries[name],
                });
                this.tour();
            })
            .catch((err: Error) => {
                // TODO
                console.log(err);
            });
    }

    componentWillUnmount() {
        this.unlisten();

        if (this.unwatch) {
            this.unwatch();
        }
        this.is_dead = true;
    }

    handleLogout = () => {
        this.props.world.logout();
    }

    async tour() {
        const should = (
            this.props.world.host.tour
            && !this.props.world.host.has_managed_queue
        );
        if (!should) {
            return;
        }
 
        const [guest, err] = await this.props.world.createGuest(
            this.state.gallery.name,
            {
                full_name: "Joe Guest",
            },
        );
        if (err) {
            // TODO
            console.log(err);
            return;
        }
        await this.props.world.createTac(
            this.state.gallery.id(),
            "https://storage.googleapis.com/public.tacboard.com/img/example1.jpg",
            "Gross, what an ugly dress",
            guest,
        );
        this.setState({tour: true});
    }

    finishTour() {
        if (this.props.world.host.tour && !this.props.world.host.has_managed_queue) {
            this.props.world.updateHost(this.props.world.host.name, {
                has_managed_queue: true,
            });
            this.setState({
                tour: false,
            });
        }
    }

    render() {
        if (!this.state.gallery) {
            // TODO spinner
            return null;
        }
        const quarantineAll = this.state.gallery.moderation === "manual";

        const tacs = _.map(this.state.tacs, (tac) => {
            const guest = this.props.world.guests[tac.guest()];
            let isQuarantined = (quarantineAll || this.features.quarantine(tac)) && tac.state !== "APPROVED";

            if (!guest) {
                return null;
            }
            if (!this.hasQuarantined && isQuarantined) {
                this.hasQuarantined = true;
            }

            return {
                tac,
                guest,
                is_low_res: this.features.isLowRes(tac),
                is_quarantined: isQuarantined,
                onDelete: () => {
                    this.props.world.deleteTac(tac.name);
                    this.finishTour();
                },
                onBlock: () => {
                    this.props.world.blockGuest(guest.name);
                    this.finishTour();
                },
                onApprove: () => {
                    this.props.world.approveTac(tac.name);
                    this.finishTour();
                },
            };
        });

        const props = {
            // remove nulls (guests not yet received)
            tacs: _.compact(tacs),
            gallery_display_name: this.state.gallery.display_name,
            tour: this.state.tour && this.hasQuarantined,

        };

        return <ManageTacs {...props} />
    }
}
